import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import _ from 'lodash';

function SelectMultipleSystem({setOption, options, isLoading}) {
    const [selectedValue, set_SelectedValue] = useState([]);
    const [isDefault, setIsDefault] = useState(true);
    const [disabled, setDisabled] = useState(false);
    const toggleLang = (option) => {
        setIsDefault(false);
        if (selectedValue.includes(option)) {
            set_SelectedValue(selectedValue.filter((item) => item !== option));
        } else {
            set_SelectedValue([...selectedValue, option]);
        }
    };
    useEffect(() => {
        if(isDefault && !_.isEmpty(options)) {
            setTimeout(() => {}, 1000);
            setOption((prev) => ({...prev, listName: options.join(', '),  amount: options.length}));
        } else {
            setOption((prev) => ({...prev, listName: selectedValue.join(', '),  amount: selectedValue.length}));
        }
    }, [selectedValue]);

    useEffect(() => {
        if(isLoading.loadingSummaryMoney || isLoading.loadingSummaryOrder || isLoading.loadingSummaryStock) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [isLoading]);

    return (
        <div>
            <Dropdown>
                <Dropdown.Toggle
                    id="dropdown-basic"
                    disabled={disabled}
                >
                    ເລືອກລະບົບ
                </Dropdown.Toggle>
                { _.isEmpty(options) ? null :
                    <Dropdown.Menu>
                        {options.map((option, index) => (
                            <Dropdown.Item
                                key={index}
                                onClick={() => toggleLang(option)}
                                active={selectedValue.includes(option)}
                            >
                                {option}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                }
            </Dropdown>
        </div>
    );
};

export default SelectMultipleSystem;